import React from 'react';
import { Coins, BarChart3, MessageSquare, DollarSign, Smile } from 'lucide-react';

export default function EmptyAnalyticsState({ 
  title = "No analytics data available", 
  message = "There is no activity recorded for this period yet. Data will appear once conversations are logged.",
  icon: CustomIcon
}) {
  const getIcon = () => {
    if (CustomIcon) return CustomIcon;
    const lowerTitle = (title || "").toLowerCase();
    if (lowerTitle.includes("token")) return Coins;
    if (lowerTitle.includes("session") || lowerTitle.includes("conversation")) return MessageSquare;
    if (lowerTitle.includes("cost")) return DollarSign;
    if (lowerTitle.includes("sentiment")) return Smile;
    return BarChart3;
  };

  const IconComponent = getIcon();

  return (
    <div className="flex flex-col items-center justify-center min-h-[340px] w-full p-8 text-center">
      <IconComponent size={32} strokeWidth={1.5} className="text-zinc-400 mb-3.5" />
      <h3 className="text-sm sm:text-base font-bold text-zinc-900 tracking-tight mb-1">
        {title}
      </h3>
      <p className="text-xs text-zinc-500 max-w-sm leading-relaxed">
        {message}
      </p>
    </div>
  );
}
